import { Component, OnInit, Input } from '@angular/core';
import { ProjectService } from '../../data/project/project.service';
import { ProjectHolder } from '../../interfaces/project-holder';
import { Project } from '../../data/project/project';
import { ProjectStatus } from '../../data/project/statuses/project-status';

@Component({
  selector: 'app-payment-status-edit',
  templateUrl: './payment-status-edit.component.html',
  styleUrls: ['./payment-status-edit.component.scss']
})
export class PaymentStatusEditComponent implements OnInit {
  project: Project;

  @Input()
  status: ProjectStatus;
  tempStatus: ProjectStatus;

  statuses: ProjectStatus[];

  constructor(
    protected projectHolder: ProjectHolder,
    private projectService: ProjectService
  ) {
    this.project = this.projectHolder.project
  }

  ngOnInit() {
    this.projectService.getPaymentStatuses().subscribe(statuses => {
      this.statuses = statuses
      if(this.status) {
        this.tempStatus = this.status;
      }
    });
  }

  statusChange(status: ProjectStatus) {
    this.status = status
    this.projectService
    .saveProject({
      id: this.project.id,
      paymentStatus: this.status
    })
    .subscribe(() => {
      this.tempStatus = this.status
    }, error => {
      this.status = this.tempStatus
    })
  }

}
